// Runtime-neutral logger. Callers pass a stable tag; runtimes set the min level.
const LEVELS = ['debug', 'info', 'warn', 'error'];
let minLevel = 'info';
function isLogLevel(value) {
    return LEVELS.includes(value);
}
export function resolveLogLevel(options) {
    if (options.logLevel && isLogLevel(options.logLevel)) {
        return options.logLevel;
    }
    return options.isProduction ? 'info' : 'debug';
}
export function configureLogger(options) {
    if (!isLogLevel(options.minLevel)) {
        throw new Error(`Invalid log level: ${String(options.minLevel)}`);
    }
    minLevel = options.minLevel;
}
function shouldLog(level) {
    return LEVELS.indexOf(level) >= LEVELS.indexOf(minLevel);
}
const baseLogger = {
    info: (...args) => shouldLog('info') && console.info(...args),
    error: (...args) => shouldLog('error') && console.error(...args),
    warn: (...args) => shouldLog('warn') && console.warn(...args),
    debug: (...args) => shouldLog('debug') && console.debug(...args),
};
export function createLogger(tag) {
    return {
        info: (msg, ...args) => baseLogger.info(`[INFO] [${new Date().toISOString()}] [${tag}] ${msg}`, ...args),
        error: (msg, ...args) => baseLogger.error(`[ERROR] [${new Date().toISOString()}] [${tag}] ${msg}`, ...args),
        warn: (msg, ...args) => baseLogger.warn(`[WARN] [${new Date().toISOString()}] [${tag}] ${msg}`, ...args),
        debug: (msg, ...args) => baseLogger.debug(`[DEBUG] [${new Date().toISOString()}] [${tag}] ${msg}`, ...args),
    };
}
//# sourceMappingURL=logger.js.map